import React,{useState,useEffect} from "react"
import {useStaticQuery, graphql,Link} from 'gatsby'
import { getImage } from 'gatsby-plugin-image'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle as faCH } from '@fortawesome/free-regular-svg-icons'
import { faCircle } from '@fortawesome/free-solid-svg-icons'

import {fontColorWhite,boxGradTwo,fontSizeFive,hoverLink,lh} from './shared.module.scss'

const FeaturedCommunities = ()=>{

    const [backgroundIndex, setBackgroundIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(false);
    

    const data = useStaticQuery(graphql`
        query {
            contentfulCorporate {
                featuredProperties{
                  gatsbyImageData
                  title
                }
          }
        }
        `
    )

    let fps = [];
    data.contentfulCorporate.featuredProperties.map((fp)=>{
        let image = getImage(fp.gatsbyImageData);
        let link_title = fp.title.split('::')
        //console.log('link_title',link_title);
        fps.push({'image':image,'title':link_title[0],'link':`/apartments/${link_title[3]}/${link_title[2]}/${link_title[1]}/`});
    });

    useEffect(() => {

        const interval = setInterval(slideAuto, 5000);
        return () => clearInterval(interval);

    }, [backgroundIndex])

    useEffect(() => {
        const handleResize = () => {
          setIsMobile(window.innerWidth < 1024); // Adjust the breakpoint as per your tablet/desktop size
        };
        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check on component mount

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const slideAuto = ()=>{
        let n = backgroundIndex + 1;
        if(n >= fps.length){
            n = 0;//loop
        }
        setBackgroundIndex(n);
    }

    return(
        <section className={boxGradTwo+" hero "+(isMobile ? '': 'is-fullheight ')} 
            style={{marginTop:'8rem',backgroundImage:'url('+fps[backgroundIndex].image.images.fallback.src+')',backgroundSize:'cover',transition: 'background-image 1s ease-in-out'}}>
            <div className=" container hero-head " >
            </div>
            <div className=" container hero-body " >
            </div>
            <div className=" container hero-foot " >
                <div className="columns is-mobile">
                    <div className="column">
                        <div className="has-text-centered" style={{position:'relative',top:'-40px'}}>
                            <h1 className={`${fontColorWhite} ${fontSizeFive} ${lh}`} style={{fontFamily: "MoonTime"}}>Featured Properties</h1>
                            <h2 className={fontColorWhite}><Link to={fps[backgroundIndex].link} 
                            className={fontColorWhite+' '+hoverLink}>{fps[backgroundIndex].title}</Link></h2>
                            <br />
                            {fps.map((f,i)=>(
                                <FontAwesomeIcon icon={ backgroundIndex == i ? faCircle : faCH } 
                                onClick={()=>{setBackgroundIndex(i)}} 
                                size="lg" 
                                key={i}
                                className={fontColorWhite}
                                style={{paddingRight:'5px',cursor:'pointer'}} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FeaturedCommunities
